import { STATUS } from "@/utils/constants";

import * as actionTypes from "./sales-order.actionTypes";

const initialState = {
  queryKey: "",
  defaultCompanySchemas: [],
  companySchemas: [],
  customSchemas: [],
  selectedRows: [],
  isFetchingCompanySchemasStatus: STATUS.IDLE,
  isFetchingCustomSchemasStatus: STATUS.IDLE,
  isSavingCompanySchemasStatus: STATUS.IDLE,
  isDuplicatingOrderStatus: STATUS.IDLE,
  isDuplicateOrderAlertVisible: false,
  isExportingModalVisible: false,
  isDeleteCustomColumnModalVisible: false,
  isDeletingColumnStatus: STATUS.IDLE,
  activeOrder: null,
  activeColumn: null,
  pagination: {
    page: 0,
    offset: 0,
    limit: 25,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_QUERY_KEY: {
      return {
        ...state,
        queryKey: action.payload,
      };
    }

    case actionTypes.SET_IS_FETCHING_COMPANY_SCHEMAS_STATUS: {
      return {
        ...state,
        isFetchingCompanySchemasStatus: action.payload,
      };
    }

    case actionTypes.SET_IS_FETCHING_CUSTOM_SCHEMAS_STATUS: {
      return {
        ...state,
        isFetchingCustomSchemasStatus: action.payload,
      };
    }

    case actionTypes.SET_IS_SAVING_COMPANY_SCHEMAS_STATUS: {
      return {
        ...state,
        isSavingCompanySchemasStatus: action.payload,
      };
    }

    case actionTypes.SET_DEFAULT_COMPANY_SCHEMAS: {
      return {
        ...state,
        defaultCompanySchemas: action.payload,
      };
    }

    case actionTypes.SET_COMPANY_SCHEMAS: {
      return {
        ...state,
        companySchemas: action.payload,
      };
    }

    case actionTypes.SET_CUSTOM_SCHEMAS: {
      return {
        ...state,
        customSchemas: action.payload,
      };
    }

    case actionTypes.SET_SELECTED_ROWS: {
      return {
        ...state,
        selectedRows: action.payload,
      };
    }

    case actionTypes.SET_ACTIVE_ORDER: {
      return {
        ...state,
        activeOrder: action.payload,
      };
    }

    case actionTypes.SET_ACTIVE_COLUMN: {
      return {
        ...state,
        activeColumn: action.payload,
      };
    }

    case actionTypes.SET_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }

    case actionTypes.SET_IS_DUPLICATE_ORDER_ALERT_VISIBLE: {
      return {
        ...state,
        isDuplicateOrderAlertVisible: action.payload,
      };
    }

    case actionTypes.SET_IS_DUPLICATING_ORDER_STATUS: {
      return {
        ...state,
        isDuplicatingOrderStatus: action.payload,
      };
    }

    case actionTypes.SET_IS_EXPORTING_MODAL_VISIBLE: {
      return {
        ...state,
        isExportingModalVisible: action.payload,
      };
    }

    case actionTypes.SET_IS_DELETE_CUSTOM_COLUMN_MODAL_VISIBLE: {
      return {
        ...state,
        isDeleteCustomColumnModalVisible: action.payload,
      };
    }

    case actionTypes.SET_IS_DELETING_COLUMN_STATUS: {
      return {
        ...state,
        isDeletingColumnStatus: action.payload,
      };
    }

    case actionTypes.RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
